export default __webpack_public_path__ + "static/e8f14cd4ba6037afe2bd2a9ec1405a72.png";